// import React, { useState } from "react";
// // import axios from "axios";
// import { supabase } from "../lib/supabase";
// import { toast } from "sonner";
// import { Mail, Globe, MapPin, ArrowUpRight } from "lucide-react";
// import Reveal, { SectionLabel } from "../components/Reveal";
// import { Input } from "../components/ui/input";
// import { Textarea } from "../components/ui/textarea";
// import { BRAND } from "../lib/constants";
// import { Helmet } from "react-helmet-async";

// <Helmet>
// <title>
// Contact | JustZeta
// </title>

// <meta
// name="description"
// content="Contact JustZeta for conference, university, hackathon or institution certificate preservation solutions."
// />
// <meta property="og:type" content="website" />

// <meta property="og:site_name" content="JustZeta" />

// <meta property="og:title"
// content="JustZeta - Secure Digital Certificate Preservation"
// />

// <meta property="og:description"
// content="Long-term preservation of digital certificates and research papers."
// />

// <meta property="og:image"
// content="https://justzeta.com/logo.png"
// />

// <meta property="og:url"
// content="https://justzeta.com"
// />
// <meta name="twitter:card" content="summary_large_image"/>

// <meta
// name="twitter:title"
// content="JustZeta"
// />

// <meta
// name="twitter:description"
// content="Secure digital certificate preservation."
// />

// <meta
// name="twitter:image"
// content="https://justzeta.com/logo.png"
// />
// <link
// rel="canonical"
// href="https://justzeta.com/contact"
// />
// </Helmet>
// // const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// export default function Contact() {
//   const [form, setForm] = useState({ name: "", organization: "", email: "", phone: "", message: "" });
//   const [submitting, setSubmitting] = useState(false);

//   const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

//   // const onSubmit = async (e) => {
//   //   e.preventDefault();
//   //   if (!form.name || !form.email || !form.message) {
//   //     toast.error("Please fill in name, email and message.");
//   //     return;
//   //   }
//   //   setSubmitting(true);
//   //   try {
//   //     await axios.post(`${API}/contact`, form);
//   //     toast.success("Thanks — we'll get back to you shortly.");
//   //     setForm({ name: "", organization: "", email: "", phone: "", message: "" });
//   //   } catch (err) {
//   //     const msg = err?.response?.data?.detail || "Something went wrong. Please try again.";
//   //     toast.error(typeof msg === "string" ? msg : "Submission failed.");
//   //   } finally {
//   //     setSubmitting(false);
//   //   }
//   // };
// const onSubmit = async (e) => {
//   e.preventDefault();

//   // 1. Basic required fields check
//   if (!form.name || !form.email || !form.message) {
//     toast.error("Please fill in all required fields (Name, Email, Message).");
//     return;
//   }

//   // 2. Email validation (RFC 5322 compliant regex)
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   if (!emailRegex.test(form.email)) {
//     toast.error("Please enter a valid email address.");
//     return;
//   }

//   // 3. Phone validation (Exactly 10 digits, optional if field is empty)
//   if (form.phone && !/^\d{10}$/.test(form.phone)) {
//     toast.error("Phone number must be exactly 10 digits.");
//     return;
//   }
// setSubmitting(true);

//   try {
//     // 1. Fetch IP Address
//     const ipResponse = await fetch("https://api.ipify.org?format=json");
//     const ipData = await ipResponse.json();
    
//     // 2. Get User Agent
//     const userAgent = navigator.userAgent;

//     // 3. Call Supabase RPC with new parameters
//     const { error } = await supabase.rpc("submit_contact_message", {
//       p_name: form.name,
//       p_organization: form.organization,
//       p_email: form.email,
//       p_phone: form.phone,
//       p_message: form.message,
//       p_ip_address: ipData.ip,
//       p_user_agent: userAgent,
//     });

//     if (error) throw error;

//     toast.success("Thanks! We'll get back to you shortly.");
//     setForm({ name: "", organization: "", email: "", phone: "", message: "" });
//   } catch (error) {
//     console.error(error);
//     let message = error.message;

//     if (error.message.includes("contact_message_length")) {
//       message = "Message must contain between 10 and 5000 characters.";
//     } else if (error.message.includes("contact_name_length")) {
//       message = "Name must contain between 2 and 100 characters.";
//     }

//     toast.error(message);
//   } finally {
//     setSubmitting(false);
//   }
// };
//   const inputCls =
//     "bg-transparent border-0 border-b border-white/15 rounded-none focus-visible:ring-0 focus:border-[#e60000] h-14 text-base px-0 text-white placeholder:text-neutral-600";

//   return (
//     <div data-testid="page-contact">
//       <section className="border-b border-white/10 py-24 md:py-32">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <SectionLabel index={1}>Contact</SectionLabel>
//           <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
//             <h1 className="lg:col-span-8 font-serif-display text-5xl md:text-7xl leading-[1.02]">
//               Start an archival <br />
//               conversation.
//             </h1>
//             <p className="lg:col-span-4 text-neutral-400 leading-relaxed">
//               Tell us about your event or institution and the number of certificates you'd like
//               to preserve. We'll respond with a tailored plan within one business day.
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="border-b border-white/10 py-24 md:py-32">
//         <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
//           <div className="lg:col-span-5 space-y-10">
//             <Reveal>
//               <div className="border border-white/10 p-8">
//                 <div className="overline mb-3">Website</div>
//                 <a href={BRAND.website} target="_blank" rel="noreferrer" className="font-serif-display text-3xl hover-underline flex items-center gap-3">
//                   <Globe size={20} /> justzeta.com
//                 </a>
//               </div>
//             </Reveal>
//             <Reveal delay={0.05}>
//               <div className="border border-white/10 p-8">
//                 <div className="overline mb-3">Email</div>
//                 <a href={`mailto:${BRAND.email}`} className="font-serif-display text-3xl hover-underline flex items-center gap-3">
//                   <Mail size={20} /> {BRAND.email}
//                 </a>
//               </div>
//             </Reveal>
//             <Reveal delay={0.1}>
//               <div className="border border-white/10 p-8">
//                 <div className="overline mb-3">Response time</div>
//                 <p className="font-serif-display text-2xl">Within one business day.</p>
//                 <p className="text-neutral-400 mt-2 text-sm">Enterprise & institutional queries prioritised.</p>
//               </div>
//             </Reveal>
//           </div>

//           <div className="lg:col-span-7">
//             <form onSubmit={onSubmit} data-testid="contact-form" className="border border-white/10 bg-[#0a0a0a] p-8 md:p-10">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//                 <div>
//                   <label className="overline block mb-3">Name *</label>
//                   <Input name="name" value={form.name} onChange={onChange} data-testid="contact-input-name" className={inputCls} placeholder="Your full name" />
//                 </div>
//                 <div>
//                   <label className="overline block mb-3">Organization</label>
//                   <Input name="organization" value={form.organization} onChange={onChange} data-testid="contact-input-org" className={inputCls} placeholder="Institution, company or event" />
//                 </div>
//                 <div>
//                   <label className="overline block mb-3">Email *</label>
//                   <Input type="email" name="email" value={form.email} onChange={onChange} data-testid="contact-input-email" className={inputCls} placeholder="you@company.com" />
//                 </div>
//                 <div>
//                   <label className="overline block mb-3">Phone</label>
//                  <Input 
//   type="tel"
//   name="phone" 
//   value={form.phone} 
//   onChange={onChange} 
//   pattern="[0-9]{10}"
//   maxLength={10} 
//   className={inputCls} // Prevents typing more than 10 digits
//   placeholder="1234567890" 
// />
//                 </div>
//                 <div className="md:col-span-2">
//                   <label className="overline block mb-3">Message *</label>
//                   <Textarea
//                     name="message"
//                     value={form.message}
//                     onChange={onChange}
//                     data-testid="contact-input-message"
//                     className="bg-transparent border-0 border-b border-white/15 rounded-none focus-visible:ring-0 focus:border-[#e60000] text-base px-0 text-white placeholder:text-neutral-600 min-h-[50px] resize-none"
//                     placeholder="Tell us about your event, participant count and retention needs…"
//                   />
//                 </div>
//               </div>

//               <button
//                 type="submit"
//                 disabled={submitting}
//                 data-testid="contact-submit"
//                 className="mt-10 bg-[#e60000] hover:bg-[#ff1a1a] disabled:opacity-50 text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3 transition-colors"
//               >
//                 {submitting ? "Sending…" : "Send message"} <ArrowUpRight size={18} />
//               </button>
//             </form>
//           </div>
//         </div>
//       </section>

//       {/* <section className="border-b border-white/10">
//         <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
//           <SectionLabel index={2}>Find us</SectionLabel>
//           <h2 className="font-serif-display text-4xl md:text-5xl mt-6">Where we operate.</h2>
//           <div className="mt-12 border border-white/10 aspect-[16/8] w-full overflow-hidden relative bg-[#0a0a0a]">
//             <div className="absolute inset-0 flex items-center justify-center">
//               <div className="text-center">
//                 <MapPin className="mx-auto text-[#e60000]" size={40} strokeWidth={1.2} />
//                 <p className="mt-4 font-serif-display text-2xl">Map placeholder</p>
//                 <p className="text-neutral-500 mt-2 text-sm max-w-md">
//                   A Google Maps embed can be dropped into this container later — the aspect ratio
//                   and container are already prepared.
//                 </p>
//               </div>
//             </div>
//             <div
//               className="absolute inset-0 opacity-30"
//               style={{
//                 backgroundImage:
//                   "linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)",
//                 backgroundSize: "40px 40px",
//               }}
//             />
//           </div>
//         </div>
//       </section> */}
//     </div>
//   );
// }

import React, { useState } from "react";
import { supabase } from "../lib/supabase";
import { toast } from "sonner";
import { Mail, Globe, ArrowUpRight } from "lucide-react";
import Reveal, { SectionLabel } from "../components/Reveal";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { BRAND } from "../lib/constants";
import { Helmet } from "react-helmet-async";

export default function Contact() {
  const [form, setForm] = useState({ name: "", organization: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();

    // 1. Basic required fields check (ALL fields are now required)
    if (!form.name || !form.organization || !form.email || !form.phone || !form.message) {
      toast.error("Please fill in all required fields (Name, Organization, Email, Phone, Message).");
      return;
    }

    // 2. Email validation (RFC 5322 compliant regex)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    // 3. Phone validation (Exactly 10 digits)
    if (!/^\d{10}$/.test(form.phone)) {
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }
    
    setSubmitting(true);

    try {
      // 1. Fetch IP Address
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      
      // 2. Get User Agent
      const userAgent = navigator.userAgent;

      // 3. Call Supabase RPC with parameters
      const { error } = await supabase.rpc("submit_contact_message", {
        p_name: form.name,
        p_organization: form.organization,
        p_email: form.email,
        p_phone: form.phone,
        p_message: form.message,
        p_ip_address: ipData.ip,
        p_user_agent: userAgent,
      });

      if (error) throw error;

      toast.success("Thanks! We'll get back to you shortly.");
      setForm({ name: "", organization: "", email: "", phone: "", message: "" });
    } catch (error) {
      console.error(error);
      let message = "";

      // Handle specific database errors
      if (error.message.includes("contact_message_length")) {
        message = "Message must contain between 10 and 5000 characters.";
      } else if (error.message.includes("contact_name_length")) {
        message = "Name must contain between 2 and 100 characters.";
      } else if (error.message.includes("rate_limit_exceeded")) {
        message = "You have already submitted a request in the last 48 hours.";
      }

      toast.error(message);
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls =
    "bg-transparent border-0 border-b border-white/15 rounded-none focus-visible:ring-0 focus:border-[#e60000] h-14 text-base px-0 text-white placeholder:text-neutral-600";

  return (
    <div data-testid="page-contact">
      <Helmet>
        <title>Contact | JustZeta</title>
        <meta
          name="description"
          content="Contact JustZeta for conference, university, hackathon, or institution certificate management solutions."
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="JustZeta" />
        <meta property="og:title" content="JustZeta - Certificate Management Platform" />
        <meta property="og:description" content="Generate, manage, and verify digital certificates and research papers." />
        <meta property="og:image" content="https://justzeta.com/logo.png" />
        <meta property="og:url" content="https://justzeta.com/contact" />
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:title" content="JustZeta" />
        <meta name="twitter:description" content="Secure certificate management and verification." />
        <meta name="twitter:image" content="https://justzeta.com/logo.png" />
        <link rel="canonical" href="https://justzeta.com/contact" />
      </Helmet>
      
      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel index={1}>Contact</SectionLabel>
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <h1 className="lg:col-span-8 font-serif-display text-5xl md:text-7xl leading-[1.02]">
              Streamline your <br /><span className="text-[#e60000]">
              certifications.</span>
            </h1>
            <p className="lg:col-span-4 text-neutral-400 leading-relaxed">
              Tell us about your event or institution and the volume of certificates you need
              to generate and manage. We'll respond with a tailored plan within one business day.
            </p>
          </div>
        </div>
      </section>

      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 space-y-10">
            <Reveal>
              <div className="border border-white/10 p-8">
                <div className="overline mb-3">Website</div>
                <a href={BRAND.website} target="_blank" rel="noreferrer" className="font-serif-display text-3xl hover-underline flex items-center gap-3">
                  <Globe size={20} /> justzeta.com
                </a>
              </div>
            </Reveal>
            <Reveal delay={0.05}>
              <div className="border border-white/10 p-8">
                <div className="overline mb-3">Email</div>
                <a href={`mailto:${BRAND.email}`} className="font-serif-display text-3xl hover-underline flex items-center gap-3">
                  <Mail size={20} /> {BRAND.email}
                </a>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="border border-white/10 p-8">
                <div className="overline mb-3">Response time</div>
                <p className="font-serif-display text-2xl">Within one business day.</p>
                <p className="text-neutral-400 mt-2 text-sm">Enterprise & institutional queries prioritised.</p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <form onSubmit={onSubmit} data-testid="contact-form" className="border border-white/10 bg-[#0a0a0a] p-8 md:p-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <label className="overline block mb-3">Name</label>
                  <Input name="name" value={form.name} onChange={onChange} data-testid="contact-input-name" className={inputCls} placeholder="Your full name" />
                </div>
                <div>
                  <label className="overline block mb-3">Organization</label>
                  <Input name="organization" value={form.organization} onChange={onChange} data-testid="contact-input-org" className={inputCls} placeholder="Institution, company or event" />
                </div>
                <div>
                  <label className="overline block mb-3">Email</label>
                  <Input type="email" name="email" value={form.email} onChange={onChange} data-testid="contact-input-email" className={inputCls} placeholder="you@company.com" />
                </div>
                <div>
                  <label className="overline block mb-3">Phone</label>
                 <Input 
                  type="tel"
                  name="phone" 
                  value={form.phone} 
                  onChange={onChange} 
                  pattern="[0-9]{10}"
                  maxLength={10} 
                  className={inputCls} 
                  placeholder="1234567890" 
                />
                </div>
                <div className="md:col-span-2">
                  <label className="overline block mb-3">Message</label>
                  <Textarea
                    name="message"
                    value={form.message}
                    onChange={onChange}
                    data-testid="contact-input-message"
                    className="bg-transparent border-0 border-b border-white/15 rounded-none focus-visible:ring-0 focus:border-[#e60000] text-base px-0 text-white placeholder:text-neutral-600 min-h-[50px] resize-none"
                    placeholder="Tell us about your event, participant count, and certificate management needs…"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={submitting}
                data-testid="contact-submit"
                className="mt-10 bg-[#e60000] hover:bg-[#ff1a1a] disabled:opacity-50 text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3 transition-colors"
              >
                {submitting ? "Sending…" : "Send message"} <ArrowUpRight size={18} />
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}